import { TFunction } from "i18next";
import * as Yup from "yup";
import { PhoneNumberUtil } from "google-libphonenumber";
import { TimeZoneProxy } from "@me-team/host/main/graphql/types";

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone: string) => {
    try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch {
        return false;
    }
};

interface Option {
    value: any;
    label: string;
}

interface Country {
    id: number;
    name: string;
    timezone?: { id: number; name: string }[];
}

interface Currency {
    id: number;
    code: string;
    currency: string;
}

export const updateCompanyFormValidationSchema = (t: TFunction, enabledMenuModule: boolean) => {
    const baseShape: Record<string, any> = {
        name: Yup.string().required(t("validation.required")),
        country: Yup.string().required(t("validation.required")),
        city: Yup.number()
            .nullable()
            .test("city-required-if-no-otherCity", t("validation.required"), function (value) {
                const otherCity = this.resolve(Yup.ref("otherCity"));
                return otherCity ? true : value !== null && value !== undefined;
            }),
        otherCity: Yup.string()
            .nullable()
            .test("otherCity-required-if-no-city", t("validation.required"), function (value) {
                const city = this.resolve(Yup.ref("city"));
                return city !== -1 ? true : value !== null && value !== undefined && value !== "";
            }),
        address: Yup.string().required(t("validation.required")),
        phone: Yup.string()
            .required(t("validation.required"))
            .test("is-valid-phone", t("Phone number is not valid"), (value) => isPhoneValid(value || "")),
        timezone: Yup.number().required(t("validation.required")),
        currency: Yup.number().required(t("validation.required")),
    };

    if (!enabledMenuModule) {
        return Yup.object().shape(baseShape);
    }

    return Yup.object().shape({
        ...baseShape,
        languages: Yup.array().min(1, t("validation.required")).required(t("validation.required")),
        primaryLanguage: Yup.number().required(t("validation.required")),
    });
};

export const countryOptionsList = (relationsData: any): Option[] =>
    relationsData?.relations?.countries?.map((country: Country) => ({
        value: country.id,
        label: country.name,
    })) || [];

export const currencyOptionsList = (relationsData: any): Option[] =>
    relationsData?.relations?.currencies?.map((currency: Currency) => ({
        value: currency.id,
        label: `${currency.code} - ${currency.currency}`,
    })) || [];

export const timezoneOptionsList = (timezones: TimeZoneProxy[]): Option[] =>
    timezones?.map((timezone) => ({
        value: timezone?.id,
        label: timezone?.name,
    })) || [];
